import { TStoryContentElementTypeRawHtml } from "@dl/declarations";
import parse from 'html-react-parser';

/** Tags that are invalid when nested inside a div (e.g. document-level elements). */
const UNWRAP_TAGS = ['html', 'head', 'body'];

/** Strip/unwrap tags that break the CMS when nested in a div. */
function sanitizeHtmlForEmbed(html: string): string {
    let result = html;

    // Unwrap document-level tags: remove opening and closing tag, keep inner content
    for (const tag of UNWRAP_TAGS) {
        const openRegex = new RegExp(`<${tag}(?:\\s[^>]*)?>`, 'gi');
        const closeRegex = new RegExp(`</${tag}>`, 'gi');
        result = result.replace(openRegex, '').replace(closeRegex, '');
    }

    // Replace deprecated <center> with a div so layout is preserved
    result = result.replace(/<center(\s[^>]*)?>/gi, '<div class="embed-center"$1>');
    result = result.replace(/<\/center>/gi, '</div>');

    return result;
}

interface HTMLEmbedProps {
    config: Pick<TStoryContentElementTypeRawHtml, "content">
}

export const HTMLEmbed: React.FC<HTMLEmbedProps> = (props) => {
    const { config } = props;

    if (config.content) {
        const sanitized = sanitizeHtmlForEmbed(config.content);
        return parse(sanitized) as React.ReactElement;
    }

    return null;
}
